import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Component as BrComponent, Page } from '@bloomreach/spa-sdk';
import { AlertService } from '@accounts/services/alert.service';
import {
  NotificationDetails,
  NotificationTypes,
} from '@accounts/site-alerts/site-alerts.interface';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'ft-site-outage',
  templateUrl: './site-outage.component.html',
})
export class SiteOutageComponent implements OnInit, OnDestroy {
  /**
   * The Bloomreach component
   */
  @Input() component!: BrComponent;
  /**
   * The Notification details
   */
  @Input() notificationDetails: NotificationDetails;
  /**
   * The Bloomreach page
   */
  @Input() page!: Page;

  private unsubscribe$: Subject<void> = new Subject<void>();

  /**
   * Alerts component parameters
   */
  // TODO: Check boolean options if they need to be configurable.
  hasBorders = true;
  hasRadius = false;
  hasShadow = false;
  hasIcon = true;
  inline = false;
  canClose: boolean;
  title: string;
  subtitle: string;
  linkInput: string;
  body: string;
  notificationType: NotificationTypes;
  primaryBtnText = '';
  secondaryBtnText = '';
  tertiaryBtnText = '';

  constructor(public alertService: AlertService) {
    this.alertService
      .getOutage$()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((notificationData) => {
        this.notificationDetails = notificationData;
        this.setNotifications();
      });
  }

  ngOnInit(): void {
    this.setNotifications();
  }

  /**
   * Function for set notification details and show or hide the alert component
   */
  setNotifications(): void {
    if (this.notificationDetails && this.notificationDetails.active) {
      this.alertService.showOutage = true;
      this.notificationType = this.notificationDetails.notificationType;
      this.subtitle = this.notificationDetails.subTitle;
      this.linkInput = null;
      // Site Outage Alert gets data directly from document, not labelkeys
      this.title = this.notificationDetails.title;
      this.body = this.notificationDetails.notificationLabel;
      this.canClose = this.notificationDetails.canClose;
      this.primaryBtnText = this.notificationDetails.primaryBtnText;
      this.secondaryBtnText = this.notificationDetails.secondaryBtnText;
      this.tertiaryBtnText = this.notificationDetails.tertiaryBtnText;
      this.subtitle = this.notificationDetails.subTitle;
      this.linkInput = null;
    }
  }

  closeOutage(): void {
    this.alertService.isOutageDismissed = true;
    this.alertService.showOutage = false;
    this.alertService.clearOutage();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
